import React from 'react';

import styles from '../../Form/CheckBox/checkBox.scss';

const CheckboxSA = props => (
    <div className={`${styles.checkBox}`}>
        <div className="input-wrapper">
            <input type="checkbox" {...props} />
            <div>
                <label>
                    <div className={`${styles.customCheckBox}`}>
                        <span
                            className={`${styles.customCheckIcon} ${props.disabled ? styles.disabled : ''} ${props.checked ? 'fas fa-check' : ''}  ${props.checked ? styles.checked : ''}`}
                            onClick={() => {
                                if (!(props.disabled || props.readOnly) && props.onChange) {
                                    props.onChange();
                                }
                            }}
                        />
                    </div>
                </label>
            </div>
        </div>
    </div>
);

export default CheckboxSA;
